import { Button } from "@progress/kendo-react-buttons";

$.fn.showMessageInWindow = function (options) {

    this.each(function () {

        $(this).showMessage({
            Type: options.type,
            Title: options.title,
            Text: options.text,
            Html: options.html,
            CssClass: options.cssClass,
            ShowInWindow: true,
            WinOptions: {
                title: options.winTitle,
                modal: true,
                draggable: true,
                actions: ['Close'],
                close: function (e) {

                    cafm.msg.removeMessageWindow(e.sender);
                    $(window).off('click.winmsg');

                    if (isFunc(options.onClose)) {

                        options.onClose(e);
                    }
                },
                activate: function (e) {

                    if (isUndefined(options.closeOnClick) || options.closeOnClick) {

                        $(window).on('click.winmsg touchend.winmsg', function () {

                            e.sender.close();
                        });

                        e.sender.element.on('click.winmsg touchend.winmsg', function () {

                            return false;
                        });
                    }

                    if (isUndefined(options.showCloseButton) || options.showCloseButton) {

                        var winButtons = $('<menu />', {

                            'class': 'cTb winButtons',
                            'data-handler': 'cafm.toolbar.closeToolbar'
                        }).append($('<button />', {

                            'class': 'btn',
                            'data-key': 'Close',
                            'data-bind': 'click: close',
                            'text': cafm.res.str.TextClose
                        })).appendTo(e.sender.element).setupToolbar();

                        cafm.util.positionWindowButtons({
                            container: winButtons
                        });
                    }
                }
            }
        });


    });
}

$.fn.showMessage = function (options) {
    /// <summary>show a formatted message on the element</summary>
    /// <param name="options" type="Object">The message options</param>
    /// <returns type="JQueryObject">Returns the JQuery element(s)</returns>
    
    if (!options) {

        options = {};
    }

    // set vars by getting property values with case insensitivity
    var type = cafm.util.getProperty(options, 'type'),
        tit = cafm.util.getProperty(options, 'title'),
        txt = cafm.util.getProperty(options, 'text'),
        html = cafm.util.getProperty(options, 'html'),
        cssClass = cafm.util.getProperty(options, 'cssClass'),
        allowDetailToggle = cafm.util.getProperty(options, 'allowDetailToggle'),
        showInWindow = cafm.util.getProperty(options, 'showInWindow'),
        transition = cafm.util.getProperty(options, 'transition'),
        winOptions = cafm.util.getProperty(options, 'winOptions'),
        scrollToTop = cafm.util.getProperty(options, 'scrollToTop'),
        icoAlt = cafm.util.getProperty(options, 'icoAlt'),
        link = cafm.util.getProperty(options, 'link'),
        buttons = cafm.util.getProperty(options, 'buttons'),
        defaults = cafm.msg.getDefaultOptions(),            
        hideDetails = cafm.util.getProperty(options, 'hideDetails'),
        prepend = cafm.util.getProperty(options, 'prepend');

    // set the default message type if not specified
    if (!type) type = defaults.type;

    // set the default transition if not specified
    if (isNullOrUndefined(transition)) transition = defaults.transition;

    this.each(function () {

        var msgCss,
            loadingMessage = options.LoadingMessage || options.loadingMessage,
            jMsg = $(this);

        // if not loading message..
        if (!loadingMessage) {

            // ensure the element has an msgPnl or poopupMsg class or contains a child with such
            if (!(jMsg.hasClass('msgPnl') || jMsg.hasClass('popupMsg'))) {

                var match = $('.msgPnl:not(.staticMsgPnl):first', jMsg);

                if (match.length) {

                    jMsg = match;
                }
                else {

                    match = $('.popupMsg:first', jMsg);

                    if (match.length) {

                        jMsg = match;
                    }
                    else {

                        if (prepend)
                            jMsg = $('<div/>', {
                                'class': 'msgPnl'
                            }).prependTo(jMsg);
                        else 
                            jMsg = $('<div/>', {
                                'class': 'msgPnl'
                            }).appendTo(jMsg);
                    }
                }
            }

            // remove existing items from message element
            jMsg.children().remove();

            // stop now if there is no title
            if (!tit || !(tit = tit.trim())) return;

            // determine default css class, icon and icon alt for message type
            switch (type) {
                default:
                    msgCss = 'msgInfo';
                    if (!icoAlt) icoAlt = 'Info';
                    break;
                case cafm.enums.MessageType.Untyped:
                    msgCss = 'msgUntyped';
                    break;
                case cafm.enums.MessageType.Success:
                    msgCss = 'msgSuccess';
                    if (!icoAlt) icoAlt = 'Success';
                    break;
                case cafm.enums.MessageType.Warning:
                    msgCss = 'msgWarning';
                    if (!icoAlt) icoAlt = 'Warning';
                    break;
                case cafm.enums.MessageType.Error:
                    msgCss = 'msgError';
                    if (!icoAlt) icoAlt = 'Error';
                    break;

            }

            // append custom css class if specified
            if (cssClass) msgCss += (' ' + cssClass);

            // remove default css and reapply full css for message
            jMsg.removeClass('msgInfo msgSuccess msgWarning msgError msgUntyped').addClass(msgCss);

            // build head and title elements
            var msgHead = $('<div/>', {
                'class': 'msgHead'
            }), msgTit = $('<span/>', {
                'class': 'msgTit',
                html: cafm.util.toSafeHtml(tit)
            });
            
            // add title element to the head element
            msgHead.prepend(msgTit);

            if (icoAlt) {

                var msgIco = $('<span>', {

                    'class': 'msgIco',
                    title: icoAlt
                });

                msgHead.prepend(msgIco);
            }

            // build link if specified
            if (link) {

                // link element
                let msgLink = $('<a/>', {

                    'class': 'msgLink'
                });

                if (link.href) {

                    msgLink.attr('href', link.href);
                }

                if (link.text) {

                    msgLink.text(link.text);
                }
                else {

                    msgLink.text(link.href);
                }

                if (link.target) {

                    msgLink.attr('target', link.target);
                }

                if (link.cssClass) {

                    msgLink.addClass(link.cssClass);
                }

                if (link.click) {

                    msgLink.click(function () {
                        cafm.util.callFunction(link.click);
                    });
                }

                // append link to message head element
                msgHead.append(msgLink);
            }

            // append message header element to message element
            jMsg.append(msgHead);
            
            // if there is detail text or HTML
            if (txt || html) {

                // bui text element
                var msgTxt = $('<div/>', {

                    'class': 'msgTxt'
                });

                // get text or HTML to set
                var t;                
                if (cafm.util.hasStringVal(txt)) {

                    t = cafm.util.toSafeHtml(txt.trim());
                }
                else if (cafm.util.hasStringVal(html)) {

                    t = cafm.util.convertLineBreaks(html.trim());
                }

                // set element HTML
                msgTxt.html(t);

                if (hideDetails) {

                    msgTxt.hide();
                }

                // append text element to message element
                jMsg.append(msgTxt);
            }
        }

        if (cafm.util.hasItem(buttons)) {
            // menu element
            let btnMenu = $('<menu>', {
                'class': 'msgMenu'
            });
            buttons.forEach(btn => {
                let props = $.extend({
                    'class': 'btn'
                }, btn);
                btnMenu.append($('<button>', props));
            });
            jMsg.append(btnMenu);
        }

        // check for window display
        if (showInWindow) {

            // if so remove existing message windows
            cafm.msg.removeMessageWindow();

            // set ID on message element
            jMsg.prop({
                id: 'msgWindow'
            });

            // defauklt win opts
            var winOpts = {
                draggable: false,
                resizable: false,
                modal: false
            };

            // add any specified window options
            if (winOptions) {
                $.extend(winOpts, winOptions);
            }

            // append message element to window
            var winMsg = $('<div />').append(jMsg),
                win = winMsg.kendoWindow(winOpts).data('kendoWindow');

            // add wrapper class, center and open it
            win.wrapper.addClass('msgWindow');
            
            if (!winOpts.title) {

                win.wrapper.find('.k-header').remove();
                var top = parseInt(win.wrapper.css('top').replace('px', '')),
                    diff = parseInt(win.wrapper.css('padding-top').replace('px', '')) / 2;
                win.wrapper.css('top', (top - diff) + 'px');
                win.wrapper.css('padding-top', 0)
            }

            win.center();
            win.open();
        }

        // hide element ready for transition
        if (transition != cafm.msg.Transition.None) jMsg.css('display', 'none');

        // if it's a loading message show the loader
        if (loadingMessage) {
            
            jMsg.showLoader({
                text: options.Title
            });
        }

        // setup detail toggle handler if specified
        if (allowDetailToggle) {

            jMsg.off('click.msgdetail').on('click.msgdetail', () => {
                $('.msgTxt', jMsg).slideToggle();
            });
        }
        
        var scrollToElement = cafm.util.getProperty('scrollToElement'),
            trans = scrollToElement ? cafm.msg.Transition.None : transition,
            parent = jMsg.parent();
        
        // if the message is in a message wrapper then make sure it's visible
        if (parent.hasClass('msgWrap')) {

            parent.show();
        }

        // show message element
        switch (trans) {
            case cafm.msg.Transition.Slide:
                jMsg.slideDown(1000);
                break;
            case cafm.msg.Transition.Fade:
                jMsg.fadeIn(1000);
                break;
            case cafm.msg.Transition.None:
                jMsg.show();
                break;
        }

        // if scroll to top is set
        if (scrollToTop) {

            var scrollable = jMsg.closest('.k-scrollable');
            if (scrollable.length) {

                scrollable.scrollTop(0);
            }
        }

        // if scroll to element
        if (scrollToElement) {

            jMsg.scrollToElement();
        }
    });
    return this;
}

$.fn.hideMessage = function (instantHide) {
    /// <summary>Hides the message element and clears its html content</summary>
    /// <returns type="JQueryObject">Returns the JQuery element(s)</returns>
    
    this.each(function () {
        var jMsg = $(this);
        if (!(jMsg.hasClass('msgPnl') || jMsg.hasClass('popupMsg'))) {
            var match = $('.msgPnl', jMsg);
            if (match.length) {
                jMsg = match;
            }
        }
        var after = function () {

            var parent = jMsg.parent();

            parent.each(function (i, el) {

                var p = $(el);
                if (p.hasClass('msgWrap')) {
                    p.hide();
                }
            });
        };
        if (instantHide === true) {
            jMsg.hide();
            after();
        }
        else {
            jMsg.fadeOut(1000, after);
        }
    });
    return this;
}

/// <summary name='cafm.msg' type='Object'>CAFM Message container object</summary>
cafm.msg = {

    /// <field name='defaultMessageOptions' type='Object'>Message type enum</field>
    defaultMessageOptions: null,
    /// <field name='Transition' type='Object'>Message transition enum</field>
    Transition: {
        None: 0,
        Fade: 1,
        Slide: 2
    },
    getDefaultOptions: function() {
    
        if (!cafm.msg.defaultMessageOptions) {

            cafm.msg.defaultMessageOptions = { type: cafm.enums.MessageType.Info, transition: cafm.msg.Transition.Fade };
        }

        return cafm.msg.defaultMessageOptions;
    },
    showMessageInWindow: function (options) {

        var mw = $('#msgWindow');
        if (mw.length) cafm.msg.removeMessageWindow();

        $('<div />', {
            id: 'msgWindow'
        }).showMessageInWindow(options);
    },
    removeMessageWindow: function (kwin) {

        if ($('#msgWindow').length) {

            if (!kwin) {

                kwin = $('#msgWindow').closest('.k-window-content').data('kendoWindow');
            }

            if (kwin) {

                setTimeout(function () {

                    cafm.util.kendoDestroy(kwin.wrapper);
                    kwin.wrapper.remove();
                }, 1000);
            }
        }
    },
    insertMessagePanelBefore: function (e) {

        var newMsgPnl = $('<div/>', {
            'class': 'msgPnl ' + cafm.res.consts.CssClass_VerticalSpaceBottom
        });
        newMsgPnl.insertBefore(e.element);
        newMsgPnl.showMessage(e.options);
    },
    prependMessagePanelTo: function (e) {

        var newMsgPnl = $('<div/>', {
            'class': 'msgPnl'
        });
        newMsgPnl.prependTo(e.element);
        newMsgPnl.showMessage(e.options);

        // ensure any wrap is visible
        var wrap = e.element.closest('.msgWrap');
        if (wrap.length) wrap.show();
    },
    appendMessagePanelTo: function (e) {

        var newMsgPnl = $('<div/>', {
            'class': 'msgPnl'
        });
        newMsgPnl.appendTo(e.element);
        newMsgPnl.showMessage(e.options);

        // ensure any wrap is visible
        var wrap = e.element.closest('.msgWrap');
        if (wrap.length) wrap.show();
    },
    showFormMessages: function (args) {
        /// <summary>Function to show messages attached to client data on a form</summary>
        /// <param name="args" type="Object">Args object. clientData = the client data object containing the messages | messagePropertyName = optional property name for the messages on the client data object. If not provided then the 'Messages' property is used | parent = Optional property to specify the parent element for the message(s). If not provided then the main form element is used.</param>

        // define vars
        var parent = args.parent, messages, msgSet;

        // get the parent element
        if (isStr(parent)) {
            parent = $(parent);
        }
        else if (!isJQuery(parent)) {

            // get the default - main form element
            parent = cafm.views.getMainForm();
        }

        // get the message set
        msgSet = parent.find('.msgSet:first');

        // get reference to the messages
        messages = isDefined(args.messagePropertyName) ? args.clientData[args.messagePropertyName] : args.clientData.Messages;

        // if there are messages
        if (cafm.util.hasItem(messages)) {

            // remove existing messages
            msgSet.find('.msgPnl').remove();

            // loop the messages
            messages.forEach(function (message) {

                message = cafm.util.clone(message);

                // if there is message text format it into a HTML list
                if (cafm.util.hasStringVal(message.Html)) {

                    message.Html = cafm.util.toUlString(message.Html);
                }

                if (args.noTransition) {

                    message.Transition = cafm.msg.Transition.None;
                }

                // append the message to the message set element
                cafm.msg.appendMessagePanelTo({
                    element: msgSet,
                    options: message
                });
            });

            msgSet.show();

            if (parent.isActionForm()) {
                parent.closestScrollable().scrollTop(0);
            }
        }
        else {

            // otherwise empty any existing messages
            msgSet.find('.msgPnl').remove();

            // hide the message set
            msgSet.hide();
        }
    }
}